/* Reuse Shopify's native predictive-search section inside the native mobile menu. */
(() => {
  'use strict';
  const states = new WeakMap();
  function initialize(root) {
    root.querySelectorAll('[data-es-mobile-predictive]').forEach(form => {
      if (states.has(form)) return;
      const input = form.querySelector('[name="q"]'), results = form.querySelector('.es-mobile-search-results');
      const clear = form.querySelector('[data-es-search-clear]'), status = form.querySelector('[data-es-search-status]');
      const menu = form.closest('.mobile-menu'), panel = form.closest('.mobile-menu__panel');
      let timer, controller, sequence = 0, suppressFocus = false;
      function close() {
        clearTimeout(timer); controller?.abort(); sequence++;
        results.hidden = true; results.removeAttribute('aria-busy'); input.setAttribute('aria-expanded', 'false');
        status.textContent = '';
      }
      function feedback(text) {
        const p = document.createElement('p'); p.className = 'es-mobile-search-feedback'; p.textContent = text;
        results.replaceChildren(p); results.hidden = false; input.setAttribute('aria-expanded', 'true'); status.textContent = text;
      }
      async function search() {
        const query = input.value.trim();
        if (!query || menu.getAttribute('aria-hidden') !== 'false' || panel.inert) { close(); return; }
        controller?.abort(); controller = new AbortController(); const version = ++sequence;
        feedback(form.dataset.loadingLabel); results.setAttribute('aria-busy', 'true');
        try {
          let supportsPredictive = false;
          try { supportsPredictive = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch === true; } catch {}
          const url = new URL(form.action, location.href);
          if (supportsPredictive) url.pathname = url.pathname.replace(/\/$/, '') + '/suggest';
          url.searchParams.set('q', query); url.searchParams.set('section_id', 'predictive-search');
          if (supportsPredictive) {
            url.searchParams.set('resources[type]', 'query,product,collection');
            url.searchParams.set('resources[limit]', '3'); url.searchParams.set('resources[limit_scope]', 'each');
            url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor');
          } else url.searchParams.set('type', 'product');
          const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('.search-ajax');
          if (!content) throw new Error('Missing search content');
          if (version !== sequence || query !== input.value.trim() || panel.inert || menu.getAttribute('aria-hidden') !== 'false') return;
          content.querySelectorAll('script').forEach(script => script.remove());
          results.replaceChildren(...content.childNodes); results.hidden = false;
          results.removeAttribute('aria-busy'); input.setAttribute('aria-expanded', 'true'); status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError' && version === sequence) {
            results.removeAttribute('aria-busy'); feedback(form.dataset.errorLabel);
          }
        }
      }
      const changed = () => {
        clear.hidden = input.value.length === 0;
        close();
        if (input.value.trim()) timer = setTimeout(search, 250);
      };
      input.addEventListener('input', changed);
      input.addEventListener('focus', () => { if (!suppressFocus && input.value.trim() && results.hidden) changed(); });
      clear.addEventListener('click', () => { input.value = ''; changed(); input.focus(); });
      form.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !results.hidden) {
          event.preventDefault(); event.stopPropagation(); close(); suppressFocus = true; input.focus(); suppressFocus = false; return;
        }
        if (results.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const targets = [...results.querySelectorAll('a[href],button:not([disabled])')];
        if (!targets.length) return;
        const index = targets.indexOf(document.activeElement), step = event.key === 'ArrowDown' ? 1 : -1;
        const next = index < 0 ? (step > 0 ? 0 : targets.length - 1) : (index + step + targets.length) % targets.length;
        event.preventDefault(); targets[next].focus();
      });
      const outside = event => { if (!form.contains(event.target)) close(); };
      document.addEventListener('click', outside);
      const observer = new MutationObserver(() => { if (panel.inert || menu.getAttribute('aria-hidden') !== 'false') close(); });
      observer.observe(menu, {attributes: true, attributeFilter: ['aria-hidden']});
      observer.observe(panel, {attributes: true, attributeFilter: ['inert']});
      states.set(form, () => { close(); observer.disconnect(); document.removeEventListener('click', outside); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-es-mobile-predictive]').forEach(form => { states.get(form)?.(); states.delete(form); }));
  document.addEventListener('click', event => document.querySelectorAll('.es-style-more[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = document.activeElement.closest('.es-style-more[open],.es-style-mobile[open]');
    if (details) { details.open = false; details.querySelector('summary').focus(); }
  });
})();
